import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";
import { registerServiceWorker } from "./lib/registerSW";
import App from "./App.tsx";
import ErrorBoundary from "./components/ErrorBoundary.tsx";
import "./index.css";

// Initialize Sentry before rendering — catches errors from first paint onward
initSentry();

// Initialize PostHog product analytics
initPostHog();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Register service worker for PWA support (production only)
registerServiceWorker();
